/* @generated */

// src/assets/ui-icon/line/pin.tsx
import * as React from "react";
var PinLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m18.84 8.04-2.878-2.878a2.253 2.253 0 0 0-3.181 0L11.19 6.748l1 1-1.94 1.94-.91-.91a2.25 2.25 0 0 0-3.182 0l-1.97 1.968 4 4-3.218 3.22 1.06 1.061 3.22-3.22 4 4 1.97-1.968a2.253 2.253 0 0 0 0-3.182l-.908-.907 1.938-1.941 1 1 1.59-1.585a2.25 2.25 0 0 0 0-3.183Zm-1.059 2.121-.531.527-1-1-4.06 4.062 1.969 1.969a.75.75 0 0 1 0 1.06l-.909.907-6.939-6.94.909-.908a.768.768 0 0 1 1.06 0l1.97 1.97 4.062-4.058-1-1 .528-.526a.749.749 0 0 1 1.061 0l2.88 2.876a.75.75 0 0 1 0 1.059v.002Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  PinLine
};
